import { faNotesMedical } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function DependantServicesGrid({ onViewService }) {

    const services = [
        {
            name: 'Health Line',
            colour: 'border-[#E7CDDB]',
            iconColour: 'bg-[#E7CDDB]',
            textColour: 'text-[#E7CDDB]',
            description:
                'Help with minor health issues, including advice on symptoms and conditions.',
            icon: faNotesMedical,
            products: [
                {
                    title: 'GP Services',
                    bookable: true,
                    description: 'Book a GP appointment for non-urgent conditions.',
                    link: 'gp-service',
                },
            ],
        },
    ]

    // Extract products from all services (currently just GP Services)
    const products = services.flatMap(service =>
        service.products.map(product => ({
            ...product,
            serviceColor: service.colour,
            serviceIconColor: service.iconColour,
            serviceIcon: service.icon
        }))
    )

    const handleProductClick = (product) => {
        // Navigate to book assessment for bookable products
        if (product.bookable) {
            window.location.href = "/book-assessment"
        } else {
            window.location.href = `/book-service/${product.link}`
        }
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {products.map((product, index) => (
                <div
                    key={index}
                    className={`bg-white rounded-xl shadow-md p-4 border-l-8 ${product.serviceColor} hover:shadow-lg transition relative group`}
                >
                    <div className="flex items-center gap-3 mb-2">
                        <div className={`${product.serviceIconColor} px-3 py-2 rounded-xl`}>
                            <FontAwesomeIcon
                                icon={product.serviceIcon}
                                className="text-[#41264B] text-lg"
                            />
                        </div>
                        <h3 className="text-[#41264B] font-semibold text-lg">
                            {product.title}
                        </h3>
                    </div>
                    <p className="text-sm text-gray-600 mb-4">
                        {product.description}
                    </p>
                    <button
                        onClick={() => handleProductClick(product)}
                        className={`${product.serviceIconColor} border-2 ${product.serviceColor} text-[#41264B] font-medium px-5 py-1.5 rounded-md hover:bg-white transition`}
                    >
                        {product.bookable ? 'Book Assessment' : 'Learn More'}
                    </button>
                </div>
            ))}
        </div>
    )
}

export default DependantServicesGrid